// Functions.
// -----------------------------------------------------------------------------
/**
 * Gets the dimensions of the image that is hosted in the url received as a
 * parameter.
 */
export const getImageDimensions = async (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener('load', () => {
            resolve({ width: img.width, height: img.height });
        });
        img.addEventListener('error', (err) => {
            reject(err);
        });
        img.src = url;
    });
};
//# sourceMappingURL=html.utils.js.map